<template>
  <div class="archive-restore-button">
    <template v-if="canBeArchived">
      <b-button :loading="loading" @click="restore" v-if="firm.archived_at">
        RESTORE
      </b-button>
      <b-button type="is-warning" :loading="loading" @click="archive" v-else>
        ARCHIVE
      </b-button>
    </template>
  </div>
</template>

<script>
import { FirmService } from "@/services/firm.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  props: {
    firm: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    // Can only archive managed firms
    canBeArchived() {
      return (
        this.$store.getters["Auth/hasRole"]("superadmin") ||
        this.$store.getters["Auth/hasRole"]("admin")
      );
    }
  },
  methods: {
    async archive() {
      try {
        this.loading = true;
        const firm = await FirmService.archive(this.firm.id)
          .then(response => JsonDenormalizer.denormalize(response));
        this.$set(this.firm, "archived_at", firm.archived_at);
        this.$emit("archive");
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    },
    async restore() {
      try {
        this.loading = true;
        const firm = await FirmService.restore(this.firm.id)
          .then(response => JsonDenormalizer.denormalize(response));
        this.$set(this.firm, "archived_at", firm.archived_at);
        this.$emit("restore");
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/partials/ArchiveRestoreButton.vue